import Announce2nd from './announce2nd';

export default class Loader {
    constructor(callback = null) {
        this.callback = callback;
        this.announce2nd = new Announce2nd();
        this._init();
    }

    _init() {
        this.setSpotLight();

        setTimeout(() => {
            document.body.classList.add('-introin');
        }, 900);

        setTimeout(() => {
            const loader = document.querySelector('.loader');
            loader.classList.add('-introshutter');
        }, 2600);

        setTimeout(() => {
            document.body.classList.add('-introend');
            if (this.callback) this.callback();
        }, 3200);

        const countdown = document.getElementById('countdown__modal');
        if (countdown) {
            setTimeout(() => {
                countdown.classList.add('-active');
                document.body.classList.add('-lock');
            }, 7000);
        }

        const announce = document.getElementById('announce2nd__modal');
        if (announce) {
            setTimeout(() => {
                announce.classList.add('-active');
                document.body.classList.add('-lock');
                this.announce2nd.startAnimation();
            }, 7000);
        }
    }

    setSpotLight() {
        const position = 4;
        const id = Math.floor(Math.random() * position) + 1;

        const loader = document.querySelector('.js-loader');
        loader.setAttribute('data-position', id);
    }
}
